class PromoBuildingCards {
  constructor(parentId, sliderId) {
    if (!window.isTouch) return;
    this.parentNode = document.getElementById(parentId);
    if (!this.parentNode) return;
    this.sliderNode = sliderId
      ? document.getElementById(sliderId)
      : this.parentNode.querySelector('[data-promo-buildings-cards]');


    if (!this.sliderNode) return;

    this.imagesLoaded = false;

    this.handleWindowScroll = this.handleWindowScroll.bind(this);
    this.handleSliderScroll = this.handleSliderScroll.bind(this);


    this.initialized = true;

    this.initColorChange();
    window.addEventListener('scroll', this.handleWindowScroll);
  }

  static isInPointWithDelta = (point, value, delta = 16) => {
    return point >= value - delta && point <= value + delta;
  };

  slideColorChange(slide) {
    if (slide && +slide.dataset.slide !== this.slideIndex) {
      this.slideIndex = +slide.dataset.slide;
      const brandColor = slide.dataset.brandColor;
      if (!brandColor) return;
      this.parentNode.style.background = brandColor;
      this.parentNode.style.setProperty('--color', '#fff');
    }
  }

  initColorChange() {
    this.slideIndex = 0;

    this.slideColorChange(this.sliderNode.querySelector('[data-slide="1"]'));

    this.sliderNode.addEventListener('scroll', this.handleSliderScroll);
  }

  handleSliderScroll() {
    const slides = this.sliderNode.querySelectorAll('[data-slide]');
    const buildingsSliderRect = this.sliderNode.getBoundingClientRect();

    const current = Array.from(slides).find((slide) => {
      const slideRect = slide.getBoundingClientRect();
      if (+slide.dataset.slide === 1) {
        return PromoBuildingCards.isInPointWithDelta(slideRect.left, 0);
      }
      if (+slide.dataset.slide === slides.length) {
        return PromoBuildingCards.isInPointWithDelta(slideRect.right, buildingsSliderRect.width);
      }

      return PromoBuildingCards.isInPointWithDelta(
        slideRect.left,
        (buildingsSliderRect.width - slideRect.width) / 2,
      );
    });

    this.slideColorChange(current);
  }

  handleWindowScroll() {
    if (this.imagesLoaded) {
      window.removeEventListener('scroll', this.handleWindowScroll);
      return;
    }
    const swiperTopPosition = this.sliderNode.getBoundingClientRect().y;
    if (window.scrollX !== swiperTopPosition + 64) {
      const images = this.sliderNode.querySelectorAll('img');
      Array.from(images).forEach((image) => image.setAttribute('loading', 'eager'));
      this.imagesLoaded = true;
    }
  }

  destroy() {
    if (!this.initialized) return;
    window.removeEventListener('scroll', this.handleWindowScroll);
    this.sliderNode.removeEventListener('scroll', this.handleSliderScroll);
  }
}

export default PromoBuildingCards;
